// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  firebase: {
    apiKey: "AIzaSyArtz_Leg3T7GN5p4zi6Cv7xrbV28r5DAg",
    authDomain: "lyceemarcellepardee.firebaseapp.com",
    projectId: "lyceemarcellepardee",
    storageBucket: "lyceemarcellepardee.appspot.com",
    messagingSenderId: "291752497687",
    appId: "1:291752497687:web:73f9bb41aa68d993298252",
    measurementId: "G-Z07WHQB63Q"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
